import React, { Component } from 'react';

import ExtranetHome from './Pages/ExtranetHome.js';
import ExtranetProjects from './Pages/ExtranetProjects.js';
import ExtranetProjectsFiche from './Pages/ExtranetProjectsFiche.js';
import ExtranetProjectsCandidates from './Pages/ExtranetProjectsCandidates.js';
import ExtranetProjectsDocuments from './Pages/ExtranetProjectsDocuments.js';
import ExtranetContacts from './Pages/ExtranetContacts.js';
import ExtranetMessages from './Pages/ExtranetMessages.js';
import ExtranetDocuments from './Pages/ExtranetDocuments.js';
import ExtranetCandidates from './Pages/ExtranetCandidates.js';
import ExtranetCandidatesFiche from './Pages/ExtranetCandidatesFiche.js';
import ExtranetCandidatesProjects from './Pages/ExtranetCandidatesProjects.js';
import ExtranetCandidatesDocuments from './Pages/ExtranetCandidatesDocuments.js';
import ExtranetCandidatesMessages from './Pages/ExtranetCandidatesMessages.js';
import ExtranetSignOut from './Pages/ExtranetSignOut.js';
import ExtranetSettings from './Pages/ExtranetSettings.js';
import ExtranetProjectsMessages from './Pages/ExtranetProjectsMessages.js';

declare var globalSns;
declare var globalExtranet;

const extranetMap = {
    extranetHome: <ExtranetHome />,
    extranetProjects: <ExtranetProjects/>,
    extranetProjectsFiche: <ExtranetProjectsFiche/>,
    extranetProjectsCandidates: <ExtranetProjectsCandidates/>,
    extranetProjectsDocuments: <ExtranetProjectsDocuments/>,
    extranetProjectsMessages: <ExtranetProjectsMessages/>,
    extranetContacts: <ExtranetContacts/>,
    extranetMessages: <ExtranetMessages/>,
    extranetDocuments: <ExtranetDocuments/>,
    extranetCandidates: <ExtranetCandidates/>,
    extranetCandidatesFiche: <ExtranetCandidatesFiche/>,
    extranetCandidatesProjects: <ExtranetCandidatesProjects/>,
    extranetCandidatesDocuments: <ExtranetCandidatesDocuments/>,
    extranetCandidatesMessages: <ExtranetCandidatesMessages/>,
    extranetSettings: <ExtranetSettings/>,
    extranetSignOut: <ExtranetSignOut/>
}

class ExtranetMain extends Component {
  render() {
    let _this = this;
    let ext = {};
    let activeComponent = globalExtranet.pages[this.props.activeComponent];

    if (activeComponent != null) {
        if (activeComponent.title != null) {
          ext.title = activeComponent.title;
        }
        if (activeComponent.content != null) {
          ext.content = activeComponent.content;    
        }    
    }
    ext.id = this.props.activeId;
    ext.title = this.props.activeTitle;
    ext.data = this.props.activeData;
    ext.onNavigate = function(pageId, id, title, data) {
      _this.props.onNavigate(pageId, id, title, data);
    }
    ext.onSubNavigate = function(pageId, data) {
      _this.props.onSubNavigate(pageId, data);
    }

    let component = React.cloneElement(extranetMap[this.props.activeComponent], ext); 

    return (
      <section id="main" className="row main">
        {component}
      </section>
    );
  }
}

export default ExtranetMain;


// WEBPACK FOOTER //
// ./src/Components/Extranet/ExtranetMain.js